import React from "react";
import * as SC from "./PostEditorPinterest.styled.js";

import { channelsByShortName } from "../../../../../data/app__channels.js";

import CampaignCreateTeaserEditor from "../../Campaign__Create_TeaserEditor/Campaign__Create_TeaserEditor.jsx";
import TemplatePostPreview from "../../TemplatePost/TemplatePost__Preview/TemplatePostPreview";
import ChannelDataEditor from "../../Campaign__Create_ChannelDataEditor.jsx";
import CampaignCreatePerformanceEditor from "../../campaign-create-performance-editor/CampaignCreatePerformanceEditor.jsx";
import useMediaAssets from "../hooks/useMediaAssets.js";
import { useTranslation } from "react-i18next";

const PostEditorPinterest = ({
  orgaId,
  postData,
  channelData,
  updatePost,
  updateChannelData,
  mobile,
  editable,
  channel,
  selectedCreativeIndexToEdit,
  setSelectedCreativeIndexToEdit,
  campaignLanguage
}) => {
  const mediaAssets = useMediaAssets(postData);
  const { t } = useTranslation();

  const templatePreviewSizes = {
    minHeight: SC.PINTEREST_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].minHeight,
    maxHeight: SC.PINTEREST_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].maxHeight,
    width: SC.PINTEREST_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].pictureWidth,
    minAspect: channelsByShortName.pinterest.minAspect,
    maxAspect: channelsByShortName.pinterest.maxAspect
  };

  return (
    <SC.PostEditorWrapper mobile={mobile}>
      <SC.PhotoEditorWrapper>
        <TemplatePostPreview
          orgaId={orgaId}
          creatives={postData.creatives}
          creativeAssets={postData.creativeAssets}
          selectedMediaAssetIndexToEdit={selectedCreativeIndexToEdit}
          mediaAssets={mediaAssets}
          updatePost={updatePost}
          channel={channel}
          editable={editable}
          templatePreviewSizes={templatePreviewSizes}
        />

        <CampaignCreatePerformanceEditor
          creatives={postData.creatives}
          creativeAssets={postData.creativeAssets}
          editable={editable}
          channel={channel}
          mediaAssets={mediaAssets}
          updatePost={updatePost}
          padding="12px 0 0 0"
          selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
          setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
        />
      </SC.PhotoEditorWrapper>

      <SC.Details>
        <SC.DetailsHeader>
          <SC.Dots />
          <SC.NoticeButton target="_blank" href={channelData.url}>
            {t("Save", { lng: campaignLanguage })}
          </SC.NoticeButton>
        </SC.DetailsHeader>
        <SC.URLWrapper>{channelData.displayLink}</SC.URLWrapper>
        <SC.TitleEditor>
          <ChannelDataEditor
            updateChannelData={updateChannelData}
            value={channelData.title}
            dataKey="title"
            textStyle={SC.titleStyle}
            limit={channelsByShortName.pinterest.limits.title}
            label={t("Job Title")}
            tooltip={t("Job Title")}
            editable={editable}
            padding="3px 8px"
          />
        </SC.TitleEditor>
        <SC.TeaserEditorWrapper>
          <CampaignCreateTeaserEditor
            channel="pinterest"
            updatePost={updatePost}
            teaserText={postData.teaserText}
            editable={editable}
            teaserTextStyle={SC.teaserTextStyle}
            limit={channelsByShortName.pinterest.limits.teaserText}
            minRows={2}
            smallButtons
            isAutoGenerated={postData?.isAutoGenerated}
            autoGeneratedText={postData?.autoGeneratedText}
            isEdited={postData?.editedStates?.teaserText}
          />
        </SC.TeaserEditorWrapper>
        <SC.DetailsFooter>
          <SC.Page>
            <SC.PageLogo src={channelData.pageLogo} alt="" />
            <div>
              <SC.PageName>{channelData.companyName}</SC.PageName>
              <SC.PageFollowers>{t("6 Followers", { lng: campaignLanguage })}</SC.PageFollowers>
            </div>
          </SC.Page>
          <SC.FollowButton>{t("Follow", { lng: campaignLanguage })}</SC.FollowButton>
        </SC.DetailsFooter>
      </SC.Details>
    </SC.PostEditorWrapper>
  );
};

export default PostEditorPinterest;
